"use client";
import {
  MenuItemCheckedContext
} from "../__chunks/ZVTAGWLT.js";
import "../__chunks/BPJQU32H.js";
import {
  useCheckboxCheck
} from "../__chunks/NEXWONOD.js";
import "../__chunks/EYKMH5G5.js";
import "../__chunks/RA2MZPUM.js";
import "../__chunks/J4JPXPLD.js";
import "../__chunks/EDI7THRR.js";
import "../__chunks/THGRQCVD.js";
import "../__chunks/UUT76IPH.js";
import "../__chunks/JS4W7WDG.js";
import {
  createElement,
  createHook,
  forwardRef
} from "../__chunks/I6MSISV2.js";
import "../__chunks/FPBGCFAS.js";
import "../__chunks/KQWO6ME3.js";
import {
  __objRest,
  __spreadProps,
  __spreadValues
} from "../__chunks/4R3V3JGP.js";

// src/menu/menu-item-check.tsx
import { useContext } from "react";
var TagName = "span";
var useMenuItemCheck = createHook(
  function useMenuItemCheck2(_a) {
    var _b = _a, { store, checked } = _b, props = __objRest(_b, ["store", "checked"]);
    const context = useContext(MenuItemCheckedContext);
    checked = checked != null ? checked : context;
    props = useCheckboxCheck(__spreadProps(__spreadValues({}, props), { checked }));
    return props;
  }
);
var MenuItemCheck = forwardRef(function MenuItemCheck2(props) {
  const htmlProps = useMenuItemCheck(props);
  return createElement(TagName, htmlProps);
});
export {
  MenuItemCheck,
  useMenuItemCheck
};
